import React from 'react'
import { Form } from 'antd';
import { Grid, TextField,Snackbar } from '@material-ui/core';
import { SitesLookup } from "../../sites/components/lookupForm";
import MySnackbarContentWrapper from "../../../components/SnackBar";

class networksForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    sites: this.props.mySites ? this.props.mySites : [],
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing..."
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    this.setState({ snackOpen: true });
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let variables = { id: this.props.id, name: values.name, description: values.description };
        if(values.password === this.props.password)
        { 
          variables = { id: this.props.id, name: values.name, description: values.description }; 
        }
        
        this.props.query_f({ variables: variables }).then(result =>{
          this.props.query_networkSite({ variables: { network: result.data.createNetwork ? result.data.createNetwork.id : this.props.id, site: this.state.sites }})
          .then(result =>{
            this.setStateValues(true, "success", "Action executed with success!");
            this.props.form.resetFields();
            if(this.props.onCancel){ this.props.onCancel(); }
            localStorage.setItem('adireto-drawer-open', false);
          }, error=>{
            this.setStateValues(true, "error", "Action executed with error!");            
          });
        }, error=>{
          this.setStateValues(true, "error", "Action executed with error!");          
        });
      }
      else{
        this.setStateValues(true, "error", "Form validation failed!");
      }
    });
  }
  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }
  myChange = (value) => { 
    this.setState({ sites: value });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const myForm = this.props;
    const sitesData = { sitesData : this.state.sites};

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage}/>
        </Snackbar>
        <Grid container spacing={0}>
        <Grid item xs={12}>
          {getFieldDecorator('name', { initialValue: (this.props.name || ''), rules: [{ required: true }], })(
            <TextField id="name" label="name"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="name"/>
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('description', { initialValue: (this.props.description || ''), rules: [{ required: true }], })(
            <TextField id="description" label="description"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="description"/>
          )}
        </Grid>

        <Grid item xs={12}>
        <SitesLookup form={myForm} sitesData={sitesData} onChange={this.myChange}/>
        </Grid>
        </Grid>
        </form>
    );
  }
}

const NetworksForm = Form.create()(networksForm);

export default NetworksForm